import { createContext, useContext } from 'react'

type ThemeContextType = {
  themeName: 'light' | 'dark'
  setThemeName: (theme: 'light' | 'dark') => void
  toggleTheme: () => void
}

export const ThemeContext = createContext<ThemeContextType>({
  themeName: 'light',
  setThemeName: () => undefined,
  toggleTheme: () => undefined,
})

export const useThemeContext = () => useContext(ThemeContext)
